<script lang="ts">
import BaseLabel from '@/components/globals/BaseLabel.vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class AssignStatusLabel extends BaseLabel {
  protected color = 'is-assign'
}
</script>
